import { fromJS, OrderedMap } from 'immutable';

import ListingRecord from 'records/listing';
import { createSymbols } from 'utils/helpers';
import { resourceReducer } from 'utils/reducerGenerator';

export const {
    EDIT_IN_LISTING,
    FETCH_RANKINGS,
    FETCH_RANKINGS_SUCCESS,
    FETCH_RANKINGS_FAIL,
    RESET_LISTING,
} = createSymbols([
    'EDIT_IN_LISTING',
    'FETCH_RANKINGS',
    'FETCH_RANKINGS_SUCCESS',
    'FETCH_RANKINGS_FAIL',
    'RESET_LISTING',
]);

const editInListing = (state, { path, value }) => state.setIn(path, value);
const fetchRankings = (state, { listingId }) => state.setIn(
    ['rankingIsFetching', listingId],
    true
);
const fetchRankingsSuccess = (state, { meta, payload }) => {
    const { listingId } = meta.previousAction;
    const data = fromJS(payload.data);
    const indexBy = (list, key) => {
        return list.reduce(
            (lookup, item) => lookup.set(item.get(key), item),
            OrderedMap({})
        );
    };
    const formatDates = (ranking) => ranking.set(
        'dates',
        indexBy(ranking.get('dates'), 'date')
    );
    const keywordRankings = indexBy(data.get('keywordRankings'), 'keyword').map(formatDates);
    const reviews = formatDates(data.get('reviews'));
    const salesRankings = formatDates(data.get('salesRankings'));
    const formattedData = data.set('keywordRankings', keywordRankings)
        .set('reviews', reviews)
        .set('salesRankings', salesRankings);

    return state.mergeDeepIn(
        ['rankings', listingId],
        formattedData
    ).setIn(['rankingIsFetching', listingId], false);
};

export const { reducer, types } = resourceReducer(
    { namespace: 'LISTING', transformer: ListingRecord },
    {
        [EDIT_IN_LISTING]: editInListing,
        [FETCH_RANKINGS]: fetchRankings,
        [FETCH_RANKINGS_SUCCESS]: fetchRankingsSuccess,
    }
);

export default reducer;
